<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("report") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="form">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $t("icon image url") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.icon"
                placeholder="http://image.com/icon.png"
              />
            </div>
          </div>
        </div>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
        <!-- <pre>{{ meta }}</pre> -->
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-rounded is-primary"
            :disabled="is_form_valid"
            @click="save"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            <span class="icon"><i class="fa fa-close"></i></span>
            <span>{{ $t("close") }}</span>
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { get, post, put, generate_error_message_text } from "@/utils";

export default {
  name: "ReportPermissionsModal",
  // components: { Permissions },
  data() {
    return {
      is_shown: false,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_valid() {
      //return true;
      let v = this;
      return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {};
      this.error = "";
    },
    save() {
      let v = this;
      put("/report", v.meta)
        .then((response) => {
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
};
</script>
<style></style>
